import { createActions } from 'redux-actions';

export const {
  createProfile,
  createProfileSuccess,
  updateProfile,
  updateProfileSuccess,
  getProfileFields,
  getProfileFieldsSuccess,
  getProfilesFieldsSuccess,
} = createActions(
  'CREATE_PROFILE',
  'CREATE_PROFILE_SUCCESS',
  'UPDATE_PROFILE',
  'UPDATE_PROFILE_SUCCESS',
  'GET_PROFILE_FIELDS',
  'GET_PROFILE_FIELDS_SUCCESS',
  'GET_PROFILES_FIELDS_SUCCESS'
);
